import http from "./httpService";
import { apiUrl } from "../config";

export const getCustomersForAccountNumber = (accountNumber) => {
  return http.get(
    `${apiUrl}Customer/GetCustomersForAccountNumber?accountNumber=${accountNumber}`,
  );
};

export const getCityAndStates = () => {
  return http.get(`${apiUrl}Customer/GetCityAndStates`);
};

export const getCustomersForCityAndState = (city, state) => {
  return http.get(
    `${apiUrl}Customer/GetCustomersForCityAndState?city=${city}&state=${state}`,
  );
};

// export const getTimeCodesForCustomer = (customerId) => {
//     return http.get(`${apiUrl}Customer/GetTimeCodesForCustomer?customerId=${customerId}`);
// }

export const getTimeCodesForCityAndState = (city, state) => {
  return http.get(
    `${apiUrl}Customer/GetTimeCodesForCityAndState?city=${city}&state=${state}`,
  );
};

export const getTimeCodesForCityAndStateAndZip = (
  city,
  state,
  zip,
  signal = null,
) => {
  return http.get(
    `${apiUrl}Customer/GetTimeCodesForCityAndStateAndZip?city=${city}&state=${state}&zip=${zip}`,
    { signal: signal },
  );
};

export const getTop10CustomersForClient = () => {
  return http.get(`${apiUrl}Delivery/GetTop10List`);
};

//well it returns true for COD and false for None/"".
//No certified cash logic
export const getCustomerDefaultCODTypeSettings = (customerId) => {
  return http.get(`${apiUrl}Customer/CheckIfCodDefault?custId=${customerId}`);
};

export const getCitiesForState = (stateAbbreviation) => {
  return http.get(
    `${apiUrl}Customer/GetCitiesForState?state=${stateAbbreviation}`,
  );
};

export const getAllCustomerListUnderClient = () =>
  http.get(`${apiUrl}Customer/GetCustomerListForClient`);

export const getAllCustomerReturnRequestPermissions = () =>
  http.get(`${apiUrl}Customer/GetAllExcludedCustomer`);

export const updateCustomerReturnRequestPermission = (data) =>
  http.post(`${apiUrl}Customer/UpdateCustomerExclude`, data);

export const postCustomerReturnRequestPermission = (data) =>
  http.post(`${apiUrl}Customer/PostCustomerExclude`, data);

// Global Return Permissions
export const getGlobalReturnPermissions = () =>
  http.get(`${apiUrl}Customer/GetReturnClientExcludeInformation`);

export const postGlobalReturnPermissions = (data) =>
  http.post(`${apiUrl}Customer/PostReturnClientExclude`, data);

export const updateGlobalReturnPermissions = (data) =>
  http.post(`${apiUrl}Customer/UpdateReturnClientExclude`, data);

/**
 * @param {{invoiceNumber: string, startDate: Date, endDate: Date}} data
 */

export const getDeliveryInformation = (data) =>
  http.get(`${apiUrl}Customer/GetDeliveryInformation`, { params: data });

/**
 * @param {{invoiceNumber: string, startDate: Date, endDate: Date, dealerId: number}} data
 */

export const getOrderForReturnByManualEntry = (data) =>
  http.get(`${apiUrl}Customer/GetOrderForReturnByManualEntry`, {
    params: data,
  });
